import { Colors } from "../constants/colors";
import { FONT_FAMILIES } from "./styles";

export default {
  styleOverrides: {
    root: {
      "& .MuiDialogContent-root": {
        ...FONT_FAMILIES.LIGHT,
        fontSize: "16px",
        lineHeight: "26px",
        color: Colors.GREY50,
      },
    },
  },
};
